import { styled } from 'stitches.config'

export const CompanyFoundedRoot = styled('section', {
  position: 'relative',
  backgroundColor: '$secondary-100',
  overflow: 'hidden',
  paddingTop: '$4',
  paddingBottom: '$4',
  paddingLeft: '0 !important',
  paddingRight: '0 !important',
  '@bp2': {
    paddingTop: '$10',
  },
})

export const CompanyFoundedTitle = styled('h2', {
  color: '$primary-450',
  textAlign: 'center',
  paddingBottom: '$6',
  textWrap: 'balance',
  '@bp2': {
    paddingBottom: '$12',
  },
})

export const CompanyFoundedDeskFlex = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '$6',
  paddingBottom: '$6',
  paddingLeft: '$3',
  paddingRight: '$3',
  '@bp2': {
    paddingBottom: '0',
    gap: '$9',
    flexDirection: 'row',
  },
  '@bp3': {
    paddingLeft: '15.9vw',
    paddingRight: '15.9vw',
  },
})

export const CompanyFoundedContainer = styled('div', {
  display: 'flex',
  alignContent: 'center',
  flexDirection: 'column',
  width: '100%',

  '@bp2': {
    paddingTop: '$2',
  },
  variants: {
    reverse: {
      true: {
        '@bp2': {
          flexDirection: 'column-reverse',
        },
      },
    },
    gap: {
      large: {
        gap: '$3',
        '@bp2': {
          gap: '$6',
        },
      },
      small: {
        gap: '$3',
      },
    },
  },
})

export const CompanyFoundedImages = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: '$2',
  zIndex: '1',
  width: '100%',
  position: 'relative',
  '& img': {
    display: 'block !important',
    width: '100% !important',
    height: 'auto !important',
    objectFit: 'cover !important',
  },
  '@bp2': {
    '& img': {
      width: 'auto',
      height: 'auto',
      objectFit: 'contain',
    },
  },
})

export const CaptionContainer = styled('div', {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  '@bp2': {
    display: 'block',
  },
})

export const CompanyFoundedText = styled('div', {
  zIndex: '1',
  gap: '$3',
  '@bp2': {
    padding: '0 1rem',
  },
})

export const CompanyFoundedDescription = styled('p', {})

export const CompanyFoundedButtonContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '0',
  '@bp2': {
    marginBottom: '$12',
  },
})

export const CompanyFoundedButton = styled('button', {
  backgroundColor: '$primary-500',
  color: '$accent-white',
  zIndex: '1',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: '$primary-400',
  },
})

export const HeartImage = styled('div', {
  display: 'none',
  '@bp2': {
    display: 'block',
    textAlign: 'center',
    marginTop: '$3',
    '& img': {
      borderRadius: '0 !important',
    },
  },
})

export const HeartIcon = styled('div', {
  position: 'absolute',
  height: '6.25rem',
  width: '6.25rem',
  zIndex: '1',
  display: 'block',
  right: '-7%',
  top: '4%',
  transform: 'translateY(-50%)',
  '@bp2': {
    display: 'none',
  },
})

export const CompanyFoundedCarouselContainer = styled('div', {
  paddingRight: '$6',
  paddingLeft: '$6',
  '@bp3': {
    paddingRight: '13.5vw',
    paddingLeft: '14.1vw',
  },
})
